import { InjectionToken } from '@angular/core';
import { ConversationConfig } from '@galaxy/conversation/core';
import { ConversationChannel, PlatformLocation } from '@vendasta/conversation';
import { of } from 'rxjs';

// This exists to satisfy the conversation core module's dependency on the conversation config token.
// For the most part it isn't used, and its allowing firestore to start up. The core module allows us to reuse
// the queries for firestore.
export const INBOX_CONFIG_FOR_CONVERSATION = new InjectionToken<ConversationConfig>(
  '[Webchat Client]: Token for Conversation config',
  {
    providedIn: 'root',
    factory: function (): ConversationConfig {
      const userId$ = of('');
      const accountGroupId$ = of('');
      const country$ = of('');
      const partnerId$ = of('');
      const geographicalState$ = of('');
      const marketId$ = of('');
      const platformLocation = PlatformLocation.PLATFORM_LOCATION_BUSINESS_APP;
      const conversationChannelsEnabled$ = of([ConversationChannel.CONVERSATION_CHANNEL_WEB_CHAT]);

      return {
        userId$,
        accountGroupId$,
        partnerId$,
        country$,
        geographicalState$,
        marketId$,
        platformLocation,
        conversationChannelsEnabled$,
      };
    },
  },
);
